export class DocumentMock {
  static instance = new DocumentMock();
  mock = [
    {
      dcn: '9991234556',
      documentType: 'Email',
      note: 'This is a SIR Note.',
      dateReceived: '4/10/2025',
      url: 'https://example.com/document.pdf',
      userID: 'user123',
      requestUID: 'request456',
    },
  ];
}
